module.exports = __webpack_public_path__ + "media/newstyle/images/icon-cross-purple-3e99a6d30326e5b4bd545550cd7cde05.svg";